/* eslint-disable */
import React from 'react';
import Loadable from 'react-loadable';
import PageLoader from '../common/components/PageLoader';

const loadable = loader =>
  Loadable({
    loader,
    delay: true,
    loading: () => <PageLoader />
  });

export const routes = [
  // not found page
  {
    path: '/404',
    component: loadable(() => import('../pages/NotFound'))
  },

  // landing
  {
    path: '/:marketplace_uid',
    component: loadable(() => import('../pages/Landing')),
    exact: true,
  },

  // Marketplace module
  {
    path: '/:marketplace_uid/cart',
    component: loadable(() => import('../pages/Cart')),
    exact: true,
    //event_active: true
  },
  {
    path: '/:marketplace_uid/products',
    component: loadable(() => import('../pages/AllProducts')),
    exact: true,
  },
  {
    path: '/:marketplace_uid/orders',
    component: loadable(() => import('../pages/Orders')),
    exact: true,
  },
  {
    path: '/:marketplace_uid/order/:order_uid/charge',
    component: loadable(() => import('../pages/ChargeOrder')),
    exact: true,
    required_auth: true,
    event_active: true
  },
  {
    path: '/:marketplace_uid/checkout',
    component: loadable(() =>
      import('../pages/ChargeCreateOrder')
    ),
    exact: true
  },
  {
    path: '/:marketplace_uid/upsell',
    component: loadable(() =>
      import('../pages/Upsell')
    ),
    exact: true
  },

  // Account module pages
  {
    path: '/:marketplace_uid/profile',
    component: loadable(() => import('../pages/Profile')),
    exact: true,
    required_auth: true
  },
];
